var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.13 8.26133C20.538 8.33306 20.8105 8.72193 20.7388 9.12988L18.7438 20.4761C18.5127 21.7911 17.3705 22.75 16.0354 22.75H7.96486C6.62979 22.75 5.4876 21.7911 5.25642 20.4762L3.26146 9.12988C3.18973 8.72192 3.46229 8.33306 3.87025 8.26133C4.2782 8.18961 4.66707 8.46217 4.73879 8.87013L6.73375 20.2164C6.83885 20.8141 7.35804 21.25 7.96486 21.25H16.0354C16.6422 21.25 17.1614 20.8141 17.2664 20.2165L17.2665 20.2164L19.2615 8.87012C19.3332 8.46217 19.722 8.1896 20.13 8.26133Z",
    fill: "#7B7D7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.625 2.75C9.93464 2.75 9.375 3.30964 9.375 4V5.25H14.625V4C14.625 3.30964 14.0654 2.75 13.375 2.75H10.625ZM16.125 5.25V4C16.125 2.48122 14.8938 1.25 13.375 1.25H10.625C9.10622 1.25 7.875 2.48122 7.875 4V5.25H3C2.58579 5.25 2.25 5.58579 2.25 6C2.25 6.41421 2.58579 6.75 3 6.75H21C21.4142 6.75 21.75 6.41421 21.75 6C21.75 5.58579 21.4142 5.25 21 5.25H16.125Z",
    fill: "#7B7D7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.9d2a15a083ffdbad5abf1cc3136aade4.svg";
export { ForwardRef as ReactComponent };